/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/entity-relative-quantities';

export const EntityRelativeQuantityApi = {
  filter: async (option: EntityRelativeQuantityQuery) => {
    let url = `${pathname}/filter`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  create: async (body: CreateEntityRelativeQuantityData) => {
    try {
      const response = await entityService.post(pathname, body);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  update: async (id: string, body: UpdateEntityRelativeQuantityData = {}) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface CreateEntityRelativeQuantityData {
  quantity: {
    few_product: number;
    have_product: number;
  };
  isDefault: boolean;
  rating: number;
  ownerID: string;
}

export interface UpdateEntityRelativeQuantityData {
  quantity?: {
    few_product: number;
    have_product: number;
  };
  status?: number;
  isDefault?: boolean;
  rating?: number;
}

export interface EntityRelativeQuantityQuery {
  order?: any;
  page?: number;
  take?: number;
  skip?: number;
  reserved?: boolean;
  isDefault?: boolean;
  status?: number;
  ownerID?: string;
}
